import { useCentrixApi } from "core/hooks/useCentrixApi";

export function useClerks() {
  return useCentrixApi({
    path: "/api/app/clerk",
    parameters: { query: {} },
    fetchAll: true,
  });
}
